import communicationsSlice,
{ CommunicationsSlice as _CommunicationsSlice,
  searchChannelCommunications as _searchChannelCommunications } from './communicationsSlice'

export type CommunicationsSlice = _CommunicationsSlice
export const communicationsReducer = communicationsSlice.reducer
export const searchChannelCommunications = _searchChannelCommunications
export default communicationsSlice
